import template from './contacts-trashbin-table.pug';

export const ContactsTrashbinTableComponent = {
  template,

  bindings: {
    filter: '<',
    onFilterChange: '&',
    gridOptions: '<',
    onCheck: '&',
    checkedIds: '<'
  },

  controller: class ContactsTrashbinTableComponent {
    constructor() {
      'ngInject';
    }

    $onInit() {
    }

    applyFilter({ filter }) {
      this.onFilterChange({ $event:{ filter } });
    }

    checkIds({ checkedIds }) {
      this.onCheck({ $event: { checkedIds } });
    }

  }
};

